import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit'
import combineReducers from './redux-store/combine.Reducers'
import { ToastContainer } from 'react-toastify'
import { CookiesProvider } from 'react-cookie';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css'; //
import './App.css';
import './menu.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const store = configureStore({
  reducer: combineReducers,
  serializableCheck: false
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <CookiesProvider >

        <App />
        <ToastContainer />
        {/* <Toaster /> */}

      </CookiesProvider>
    </BrowserRouter>
  </Provider>
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
